import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  title?: string;
}
export function VideoModal({
  open,
  onClose,
  videoUrl,
  title = 'Year One Career Playbook'
}: VideoModalProps) {
  // Lock body scroll & close on Escape
  useEffect(() => {
    if (!open) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener('keydown', handleKey);
    };
  }, [open, onClose]);
  if (typeof document === 'undefined') return null;
  // Add autoplay when modal is open so video plays immediately
  const srcWithAutoplay = open ? `${videoUrl}${videoUrl.includes('?') ? '&' : '?'}autoplay=1` : '';
  return createPortal(<AnimatePresence data-id="element-199">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8 bg-ink/85 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-label={title} data-id="element-200">
          <motion.div initial={{
        scale: 0.96,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.96,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative w-full max-w-5xl aspect-video bg-ink rounded-2xl overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-201">
            <button onClick={onClose} aria-label="Close video" className="absolute -top-12 right-0 md:top-3 md:right-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white backdrop-blur-md transition-colors" data-id="element-202">
              <XIcon className="w-5 h-5" data-id="element-203" />
            </button>
            <iframe src={srcWithAutoplay} title={title} className="w-full h-full" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen data-id="element-204" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>, document.body);
}